var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-tabs',{attrs:{"dark":"","background-color":"blue-grey darken-2"}},_vm._l((_vm.getPlaces),function(place){return _c('v-tab',{key:place._id,attrs:{"to":("/place/" + (place._id))}},[_c('span',[_vm._v(_vm._s(place.placeName))])])}),1)}
var staticRenderFns = []

export { render, staticRenderFns }